<template>
  <Modal v-if="show" @close="closeModal">
    <template v-slot:header>
      <div></div>
    </template>
    <template v-slot:body>
      <br />
      <div>
        I accept that a recommendation for alternative arrangements can be made
        where, after packing has begun, it has been found that one barrel will
        be insufficient to meet my packing needs.
      </div>
    </template>
    <template v-slot:footer>
      <button class="btn btn-primary" @click="closeModal">Close</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";

export default {
  components: {
    Modal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>